module.exports = __webpack_public_path__ + "img/icon9.5bdc8826.jpg";